import { useShopSessionCookieConsentUpdateMutation } from '@/services/graphql/generated'
import { useShopSessionId } from '@/services/shopSession/ShopSessionContext'
import { parseOneTrustConsentGroups } from '@/utils/parseOneTrustConsentGroups'

export function useUpdateShopSessionConsent() {
  const shopSessionId = useShopSessionId()
  const [shopSessionCookieConsentUpdate, result] = useShopSessionCookieConsentUpdateMutation()

  const updateShopSessionConsent = () => {
    if (shopSessionId == null) return
    const consentGroups = parseOneTrustConsentGroups()
    if (consentGroups == null) return

    const preferences = Object.entries(consentGroups)
      .filter(([_, granted]) => granted === 'granted')
      .map(([label]) => label)

    return shopSessionCookieConsentUpdate({
      variables: {
        input: {
          shopSessionId,
          provider: 'ONETRUST',
          preferences: preferences,
        },
      },
    })
  }

  return { updateShopSessionConsent, error: result.error }
}
